import React from "react";
import Modal from "../../../Modal/Modal";
import Avatar from "../../../Common/Avatar";
import DotLoader from "../../../Loading/DotLoader";
import Button from "../../../Buttons/Button";
import qbLoading from "../../../../assets/qbLoading.svg";
import Logo from "../../../../assets/images/Logo.svg";

const QbAnimationLoading = ({ onClose, isOpen }) => {
  // const QbAnimationLoading = () => {
  return (
    <Modal
      titile=""
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-5xl"
      showCloseButton={false}
    >
      <div className="flex  flex-col justify-center items-center  text-center min-h-[200px]">
        <div className="flex items-center gap-4 justify-center ">
          <Avatar
            size="xxl"
            alt={"KultWorks"}
            src={Logo}
            outline
            className="border-none"
          />
          <DotLoader />
          <Avatar
            size="xxl"
            alt={"Qb"}
            src={qbLoading}
            outline
            className="border-none"
          />
        </div>
        <p className="mt-5">Please wait while we process your request...</p>
      </div>
    </Modal>
  );
};

export default QbAnimationLoading;
